// src/stage2/sceneExterior/BushesField.jsx
import React from 'react';
import { useGLTF } from '@react-three/drei';

// 🟢 Update this if your filename/path is different
const HEDGE_URL = '/stageAssets/stage2/scene/Stage2Exterior-Bushes.glb';

export function BushesField() {
  const { scene } = useGLTF(HEDGE_URL);

  if (!scene) return null;

  // All your hedge/bush placements go here.
  // These are just example coords – tweak to taste.
  const hedges = [
    //picnic table area
    { pos: [40, 1.9, 17], rot: [0, 5, 0], scale: 1 },
    { pos: [39, 1.9, 23.5], rot: [0, 4.5, 0], scale: 1 },
    { pos: [37.5, 1.9, 24.45], rot: [0, 0, 0], scale: 1 },
    { pos: [36, 1.9, 23.75], rot: [0, 0, 0], scale: 0.75 },

    //to parking lot - along fence
    { pos: [-41.6, 2, 7], rot: [0, 2, 0], scale: 0.75 },
    { pos: [-41.25, 0.5, -9.75], rot: [0, 1.75, 0], scale: 0.5 },
    { pos: [-41.25, 0.65, -8.85], rot: [0, 1.75, 0], scale: 0.5 },
    { pos: [-41.25, 0.65, -9.54], rot: [0, 1.75, 0], scale: 0.5 },
    { pos: [-41.25, 0.65, -7.75], rot: [0, 1.5, 0], scale: 0.6 },


  ];

  return (
    <>
      {hedges.map((h) => (
        <primitive
          key={h.id}
          object={scene.clone(true)}   // cheap instance clone
          position={h.pos}
          rotation={h.rot}
          scale={h.scale ?? 1}
        />
      ))}
    </>
  );
}

useGLTF.preload(HEDGE_URL);
